import * as React from 'react';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';
import {SectionLabel} from 'shells/typography/section-label';

import styles from './activities-section.module.css';

type Props = {
    startTime: number;
    endTime: number;
};

export function TimeSection(props: Props) {
    const currentTime = Date.now() / 1000;

    return (
        <div className={styles['activity-time']}>
            <SectionLabel
                size='mini'
                noBottomBorder={true}
                noBottomMargin={true}
                color={currentTime > props.endTime ? 'error' : 'medium'}
            >
                <FormattedTimestamp
                    datetime={props.startTime}
                    format={FormattedTimestamp.formats.shortMonthDay}
                />
            </SectionLabel>
            <Body size='mini' color='light' nowrap={true}>
                <FormattedTimestamp
                    datetime={props.startTime}
                    format={FormattedTimestamp.formats.time}
                />
            </Body>
        </div>
    );
}
